module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_search_feature-7ec412509fec9031d1fefbc9149359f5.svg";